import React from 'react';
import { FaTiktok, FaUsers, FaAward } from 'react-icons/fa';

const About = () => {
  return (
    <section id="about" className="py-5">
      <div className="container">
        <div className="row align-items-center">
          {/* الجانب الأيمن: صورة أو رسم بياني */}
          <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-right">
            <div className="bg-light p-5 rounded-4 text-center">
              <FaTiktok size={120} className="text-tiktok-red mb-4" />
              <h3 className="fw-bold">TikTok First Agency</h3>
              <p className="text-secondary">أول وكالة متخصصة في التيك توك بمصر والإمارات</p>
              <div className="row mt-4">
                <div className="col-6">
                  <div className="fw-bold fs-2 text-tiktok-cyan">2025</div>
                  <div className="text-secondary">تأسسنا</div>
                </div>
                <div className="col-6">
                  <div className="fw-bold fs-2 text-tiktok-red">+100</div>
                  <div className="text-secondary">صانع محتوى</div>
                </div>
              </div>
            </div>
          </div>

          {/* الجانب الأيسر: النص */}
          <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
            <div className="text-center">
              <span className="badge bg-tiktok-cyan text-black px-4 py-2 mb-4">
                ABOUT US
              </span>
            </div>
            <h2 className="display-5 fw-bold mb-4">وكالة إماراتية مصرية، تابعة لسيف الدولة</h2>
            
            <p className="lead mb-4">
              نحن لسنا مجرد وكالة إدارة أعمال، بل نحن شركاء النجاح لصُنّاع المحتوى على منصة TikTok.
            </p>

            <div className="mb-4">
              <div className="d-flex mb-3">
                <div className="me-3">
                  <FaAward className="text-tiktok-cyan" size={24} />
                </div>
                <div>
                  <h5 className="fw-bold">خبرة محلية وعالمية</h5>
                  <p className="text-secondary">نمزج بين فهم السوق المحلي والخبرات العالمية</p>
                </div>
              </div>
              <div className="d-flex mb-3">
                <div className="me-3">
                  <FaUsers className="text-tiktok-red" size={24} />
                </div>
                <div>
                  <h5 className="fw-bold">شبكة مبدعين واسعة</h5>
                  <p className="text-secondary">أكثر من 100 مبدع في مختلف المجالات</p>
                </div>
              </div>
            </div>

            <p className="fw-bold fs-5">
              إحنا مش بنوعد بكلام… إحنا بنشتغل على أرقام ونتائج. 
              لو عندك موهبة أو حساب وعايز تطوره — إنت في المكان الصح. 🚀
            </p>

            <a href="#contact" className="btn btn-danger btn-lg px-5 mt-3 text-white fw-bold border-0">
  تواصل معنا
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;